export default function getGoogleMapApiKey(): string {
  return process.env.REACT_APP_STAGE === "local"
    ? ""
    : process.env.REACT_APP_GOOGLE_API_KEY || "";
}
